import React from 'react';
import Size from './size';

const Sizes = (props) => {
    return (
      <div className="sizeElement">
        <div className="choiceContainer">
          {props.sizes.sort((a, b) => a.order_by - b.order_by).map((size, index) => (<Size
            key={size.order_by}
            index={index}
            updateSizeItem={props.updateSizeItem}
            productType={props.productType}
            data={size}
            productID={props.productID}
            customizationsAvailable={props.customizationsAvailable}
            groupID={props.groupID}
            choicesID={props.choicesID}
          />))}
        </div>
      </div>
    );
  };

export default Sizes;
